import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { heatMapOptions } from '@/metrics/pages/DashboardPage/ShipmentsMetricsContent/constants'

const OrderBySelector = ({ orderBy, onChange }) => {
  const { t } = useTranslation()

  return (
    <div style={{ width: '300px' }}>
      <ComboBox
        label={t('Mapa de calor por')}
        fullWidth
        menuItems={[
          { label: t('Número de pedidos'), value: heatMapOptions.totalOrdersCount },
          {
            label: t('Valor total de pedidos'),
            value: heatMapOptions.totalOrderValue,
          },
          {
            label: t('Valor promedio de pedido'),
            value: heatMapOptions.averageOrderValue,
          },
          {
            label: t('Número de incidentes en aduanas'),
            value: heatMapOptions.incidentsInCustoms,
          },
        ]}
        handleChange={e => onChange(e.target.value)}
        value={orderBy}
      />
    </div>
  )
}

export default OrderBySelector
